import styled from 'styled-components'
import PointerC from 'assets/images/Pointer.svg'
import { formBreakpoint } from 'globalStyles'

export const SwitchIconContainer = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 2.4rem;
  height: 2.4rem;
  border: 1px solid var(--grey-500);
  border-radius: 50%;
  background-color: var(--grey-200);
  box-shadow: 0 3px 3px 0 var(--shadow);

  position: absolute;
  left: calc(30rem - 0.8rem);

  z-index: 1;
  cursor: url(${PointerC}), pointer;

  @media (max-width: ${formBreakpoint}) {
    top: 3rem;
    left: 90%;
    & > svg {
      transform: rotate(90deg);
    }
  }
`
